import React from 'react';
import { ExploreBtnStyle } from './styled';
import { images } from '../../../../Constants/ImageUrls';
import {
  createRippleEffectRelative,
  getScreenName,
} from '../../../../Utils/helper';
import AnchorCoverTag from '../../../StoreHomePage/AnchorCoverTag';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../../Parenting/common';
import { getRouterLocale } from '../../../../Utils/i18Utils/constant';
import { fireEvent } from '../../../../Utils/fireEvent';

const ExploreMoreBtn = (props) => {
  const { data, index, sectionData, categoryId } = props;
  const exploreClickHandler = (event) => {
    createRippleEffectRelative(
      event,
      document.getElementById('explore' + index),
    );
    fireEvent({
      category: 'clicked_cta',
      cta: data?.text,
      section_id: sectionData?._id,
      section_name: sectionData?.itemName,
      screen_name: getScreenName(),
      id: categoryId,
    });
  };
  const router = useRouter();

  const exploreNavigation = (index, deeplinkValue) => {
    setTimeout(() => {
      router.push(`${deeplinkValue}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  return (
    <div className="exploreButton">
      <AnchorCoverTag
        url={data?.webUrl}
        index={index}
        callbackFunction={exploreNavigation}
        fragmentClass=""
      >
        <ExploreBtnStyle
          onClick={(e) => exploreClickHandler(e)}
          id={'explore' + index}
        >
          {data?.text}
          <img
            className="whiteArrow"
            src={images.arrowWhite}
            alt=""
            loading="lazy"
          />
          <img
            className="redArrow"
            src={images.arrowRedForward}
            alt=""
            loading="lazy"
          />
        </ExploreBtnStyle>
      </AnchorCoverTag>
    </div>
  );
};

export default ExploreMoreBtn;
